import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, message, Form, Input, Button } from 'antd';
import http from '@/assets/api/http';

const CreateAndEdit = ({
    setRenderMode,
    modeParams = {},
    setUpdateList,
    setClearParams
}) => {

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const formLayout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 19 },
    };

    const onFinish = (values) => {
        let url = '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyDisplayPositionService.addStrategyDisplayPosition';
        let tip = '新建分类字典操作成功';
        let data = {
            displayPositionCode: values.displayPositionCode,
            displayPositionName: values.displayPositionName,
            remark: values.remark
        };
        if (modeParams.id) {
            url = '/?cmd=com.xqxc.api.pig.mis.biz.platform.StrategyDisplayPositionService.updateStrategyDisplayPosition';
            tip = '编辑分类字典操作成功';
            data = {
                id: modeParams.id,
                displayPositionName: values.displayPositionName,
                remark: values.remark
            };
        }
        http(url, data, 'POST')
            .then(() => {
                message.success(tip);
                setLoading(false);
                setRenderMode(false);
                setUpdateList(true);
            }).catch((e = {}) => {
                message.error(e.message);
                setLoading(false);
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return <Modal
        width={600}
        centered
        title={modeParams.id ? '编辑分类字典' : '创建分类字典'}
        visible={true}
        confirmLoading={loading}
        onOk={onFinish}
        onCancel={() => {
            setClearParams(true);
            setRenderMode(false);
        }}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        cancelText='取消'
        okText='确认'
        footer={null}
    >
        <Form
            {...formLayout}
            key={modeParams.id}
            form={form}
            name='modeParams'
            initialValues={modeParams.id ? modeParams : {}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}>
            <Form.Item
                label='编码'
                name='displayPositionCode'
                rules={[
                    { required: true, message: '请输入编码，例如：C001-C999' }
                ]}
            >
                <Input disabled={!!modeParams.displayPositionCode} placeholder='请输入编码，例如：C001-C999' />
            </Form.Item>
            <Form.Item
                label='攻略分类名称'
                name='displayPositionName'
                rules={[
                    { required: true, message: '请输入攻略分类名称' },
                    { max: 16, message: '攻略分类名称最大16' }
                ]}
            >
                <Input placeholder='请输入攻略分类名称' />
            </Form.Item>
            <Form.Item
                label='备注'
                name='remark'
                rules={[
                    { required: true, message: '请输入至少五个字符' },
                    { min: 5, message: '备注最小5个字符' },
                    { max: 100, message: '备注最大100个字符' }
                ]}
            >
                <Input.TextArea placeholder='请输入至少五个字符' />
            </Form.Item>
            <Form.Item style={{ marginBottom: '0px', textAlign: 'right' }}>
                <Button
                    disabled={loading}
                    onClick={() => {
                        setClearParams(true);
                        setRenderMode(false);
                    }}
                >取消</Button>
                <Button
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                    style={{ marginLeft: '20px' }}
                >确定</Button>
            </Form.Item>
        </Form>
    </Modal>;
};

CreateAndEdit.propTypes = {
    modeParams: PropTypes.object,
    setRenderMode: PropTypes.func,
    setUpdateList: PropTypes.func,
    setClearParams: PropTypes.func
};

export default CreateAndEdit;
